<template>
  <div id="LoginLogs">
    <el-card class="box-card">
      <el-form size="mini" :inline="true" :model="queryMap" class="demo-form-inline">
        <el-form-item label="用户名">
          <el-input v-model="queryMap.username" :placeholder="$t('message.placeholder.input')"></el-input>
        </el-form-item>
        <el-form-item label="IP地址">
          <el-input v-model="queryMap.ip" placeholder="请输入IP查询"></el-input>
        </el-form-item>
        <el-form-item label="登入地址">
          <el-input v-model="queryMap.location" placeholder="请输入登入地址查询"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button  icon="el-icon-search" @click="search" type="primary">{{$t('message.button.search')}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="deleteFileOrDirectory(sels)" icon="el-icon-delete"  :disabled="this.sels.length === 0">批量</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域 -->
      <template>
        <el-table
          border
          stripe
          size="mini"
          :data="LoginLogData"
          style="width: 100%;"
          height="460"
          @selection-change="selsChange"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="id" type="index" label="ID" width="50"></el-table-column>
          <el-table-column prop="username" label="登入用户" width="150"></el-table-column>
          <el-table-column prop="loginTime" label="登入时间" width="190"></el-table-column>
          <el-table-column prop="location" label="登入地点" width="250"></el-table-column>
          <el-table-column prop="ip" label="IP地址"></el-table-column>
          <el-table-column prop="userSystem" label="项目名称" width="150"></el-table-column>
          <el-table-column prop="userBrowser" label="相关操作"></el-table-column>
          <el-table-column label="操作" width="100px;">
            <template slot-scope="scope">
              <el-button
               v-hasPermission="'loginLog:delete'"
                type="text"
                size="mini"
                icon="el-icon-delete"
                @click="del(scope.row.id)"
              >{{$t('message.button.delete')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!-- 分页 -->
      <el-pagination
        style="margin-top:10px;"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="this.queryMap.pageNum"
        :page-sizes="[ 10, 15, 20]"
        :page-size="this.queryMap.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sels: [], //选中的值显示
      LoginLogData: [{
		  id:"1",
		  username:"admin",
		  loginTime:"2020-10-23 14:36:41",
		  location:"中国|华东|江苏省|苏州市|电信",
		  ip:"49.34.236.96",
		  userSystem:"物料包装设计",
		  userBrowser:"提交请求"
	  },{
		  id:"2",
		  username:"admin",
		  loginTime:"2020-10-23 14:36:41",
		  location:"中国|华东|北京市|电信",
		  ip:"49.34.236.96",
		  userSystem:"D类产品招商",
		  userBrowser:"删除文档"
	  },{
		  id:"3",
		  username:"admin",
		  loginTime:"2020-10-23 14:36:41",
		  location:"中国|华东|天津市|电信",
		  ip:"49.34.236.96",
		  userSystem:"R10芯片",
		  userBrowser:"请求审批"
	  },{
		  id:"4",
		  username:"admin",
		  loginTime:"2020-10-23 14:36:41",
		  location:"中国|华东|江苏省|南京市|电信",
		  ip:"49.34.236.96",
		  userSystem:"单晶硅",
		  userBrowser:"技术审核"
	  },{
		  id:"5",
		  username:"admin",
		  loginTime:"2020-10-23 14:36:41",
		  location:"中国|华东|江苏省|苏州市|电信",
		  ip:"49.34.236.96",
		  userSystem:"R10芯片",
		  userBrowser:"请求审批"
	  },{
		  id:"6",
		  username:"admin",
		  loginTime:"2020-10-23 14:36:41",
		  location:"中国|华东|江苏省|苏州市|电信",
		  ip:"49.34.236.96",
		  userSystem:"物料",
		  userBrowser:"技术审核"
	  }],
      total: 0, //总共多少条数据
      queryMap: { pageNum: 1, pageSize: 10, location: "" } //查询对象
    };
  },
  methods: {
    async deleteFileOrDirectory() {
      var ids = this.sels.map(item => item.id).join(); //获取所有选中行的id组成的字符串，以逗号分隔
       var res = await this.$confirm(
        "此操作将永久批量删除登入日志, 是否继续?",
        this.$t('message.tips.tip'),
        {
          confirmButtonText: this.$t('message.button.affirm'),
          confirmButtonText: this.$t('message.button.cancel'),
          type: "warning"
        }
      ).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
      if (res == "confirm") {
        // const { data: res } = await this.$http.delete("loginLog/batchDelete/" + ids);
        // if (res.code == 200) {
        //   this.$message.success("登入日志删除成功");
        //   this.getLoginLogList();
        // } else {
        //   this.$message.error(res.message);
        // }
      }
    },
    selsChange(sels) {
      this.sels = sels;
    },
    //搜索
    search() {
      this.queryMap.pageNum = 1;
      this.getLoginLogList();
    },

    //加载登入日志列表
    async getLoginLogList() {
      // const { data: res } = await this.$http.get("loginLog/findLoginLogList", {
      //   params: this.queryMap
      // });
      // if (res.code !== 200) {
      //   return this.$message.error("获取列表失败");
      // } else {
      //   this.total = res.data.total;
      //   this.LoginLogData = res.data.rows;
      // }
    },
    //删除登入日志
    async del(id) {
      var res = await this.$confirm(
        "此操作将永久删除该登入日志, 是否继续?",
        this.$t('message.tips.tip'),
        {
          confirmButtonText: this.$t('message.button.affirm'),
          confirmButtonText: this.$t('message.button.cancel'),
          type: "warning"
        }
      ).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
      if (res === "confirm") {
        // const { data: res } = await this.$http.delete("loginLog/delete/" + id);
        // if (res.code === 200) {
        //   this.$message.success("登入日志删除成功");
        //   this.getLoginLogList();
        // } else {
        //   this.$message.error(res.message);
        // }
      }
    },

    //改变页码
    handleSizeChange(newSize) {
      this.queryMap.pageSize = newSize;
      this.getLoginLogList();
    },
    //翻页
    handleCurrentChange(current) {
      this.queryMap.pageNum = current;
      this.getLoginLogList();
    }
  },
  created() {
    this.getLoginLogList();
  }
};
</script>
